import React from 'react';
import Link from 'gatsby-link';
import {isMobile} from 'react-device-detect';
import github from '../img/github-icon.svg';
import logo from '../img/sjs-logo.png';
import $ from 'jquery';

function activateMobileNavbar() {
  $('.navbar-item').each(function(e) {
      $(this).click(function(){
        if($('#navbar-burger-id').hasClass('is-active')){
          $('#navbar-burger-id').removeClass('is-active');
          $('#navbar-menu-id').removeClass('is-active');
        }
      });
    });
  
  // Open or Close mobile & tablet menu
  $('#navbar-burger-id').click(function () {
      if($('#navbar-burger-id').hasClass('is-active')){
          $('#navbar-burger-id').removeClass('is-active');
          $('#navbar-menu-id').removeClass('is-active');
      }else {
          $('#navbar-burger-id').addClass('is-active');
          $('#navbar-menu-id').addClass('is-active');
      }
  });
  
}
function activateFixedNavbar() {
  if(!isMobile){
    $(document.body).css("margin-top", $("#navbar").outerHeight());
  }
  $(window).scroll(function() {
    if ($(document).scrollTop() > 200) {
      $('#navbar').addClass('is-fixed-top');
      $('body').addClass('has-navbar-fixed-top');
    } else {
      $('#navbar').removeClass('is-fixed-top');
      $('body').removeClass('has-navbar-fixed-top');
    }
  });
  $( document ).ready(function() {
    if(!isMobile){
      $(document.body).css("margin-top", $("#navbar").outerHeight());
    }
  });
  $(window).resize(function() {
    if(!isMobile){
      $(document.body).css("margin-top", $("#navbar").outerHeight());
    }
  }).resize();
}

class Navbar extends React.Component {
  
  componentDidMount() {
    activateMobileNavbar();
    activateFixedNavbar();
  }
  render () {
    return (
      <nav id="navbar" className="navbar">
        <div className="container">
          <div className="navbar-brand">
            <Link to="/" className="navbar-item">
              <figure className="image">
                <img src={logo} alt="San Juan Software" />
              </figure>
            </Link>
            <div id="navbar-burger-id" className="navbar-burger">
              <span></span>
              <span></span>
              <span></span>
            </div>
          </div>
          <div id="navbar-menu-id" className="navbar-menu">
            <div className="navbar-start">
            </div>
            <div className="navbar-end">
              <div className="navbar-item has-dropdown is-hoverable" to="/services">
                <Link className="navbar-link" to="/services">
                  Services
                </Link>
                <div className="navbar-dropdown">
                  <Link className="navbar-item" to={{ pathname: '/services', hash:'#iot'}}>
                    IoT
                  </Link>
                  <Link className="navbar-item" to={{ pathname: '/services', hash:'#aerospace'}}>
                    Aerospace
                  </Link>
                  <Link className="navbar-item" to="/case-studies">
                    Case Studies
                  </Link>
                </div>
              </div>
              <div className="navbar-item has-dropdown is-hoverable">
                <Link className="navbar-link" to="/about">
                  About
                </Link>
                <div className="navbar-dropdown">
                  <Link className="navbar-item" to="/about">
                    About SJS
                  </Link>
                  <Link className="navbar-item" to={{ pathname: '/about', hash: '#contact' }}>
                    Contact Us
                  </Link>
                  <Link className="navbar-item" to="/careers">
                    Careers
                  </Link>
                </div>
              </div>
              <div className="navbar-item has-dropdown is-hoverable">
                <Link className="navbar-link" to="/news">
                  News
                </Link>
                <div className="navbar-dropdown is-right">
                  <Link className="navbar-item" to="/iot-news">
                    IoT News
                  </Link>
                  <Link className="navbar-item" to="/aerospace-news">
                    Aerospace News
                  </Link>
                  <Link className="navbar-item" to="/events">
                    Events
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </nav>
    )
  }
}

export default Navbar;



// WEBPACK FOOTER //
// ./src/components/Navbar.js